module.exports = __webpack_public_path__ + "static/media/rotate-b2.1.91b05033.svg";